import { api } from '../lib/api.js';
import type { TvDepartment } from './tv.js';

// מרכז מנהל הייצור — /api/production-center (server: modules/production-center).

/** `queue` = כמה חלקים מחכים בתור של כל מחלקה שיש בה נוכח בלי שעון (13/10/2026). */
export type WhoWorksResponse = { now: string; departments: TvDepartment[]; queue?: Record<string, number> };
export type WorkerDayRow = { partId: string; part: string; project: string; projectName: string | null; stage: string };
export type WorkerDay = {
  name: string; department: string | null;
  done: (WorkerDayRow & { at: string })[];
  open: (WorkerDayRow & { startedAt: string })[];
};

export type MissingHoursKind = 'SKIPPED' | 'DONE_ZERO';
export type MissingHoursRow = {
  key: string;
  kind: MissingHoursKind;
  partId: string;
  partNumber: string;
  partName: string | null;
  projectNumber: string;
  projectName: string | null;
  sequenceIndex: number;
  stageName: string;
  departmentName: string | null;
  who: string | null;
  at: string | null;
  how: string;
  stdMinutes: number | null;
};
export type MissingHoursResponse = { rows: MissingHoursRow[]; pendingCredit: number; checkedAt: string };
export type MissingHoursFill = { key: string; minutes?: number; notDone?: boolean; reason?: string };

const B = '/api/production-center';

export const productionCenterApi = {
  whoWorks: () => api<WhoWorksResponse>(`${B}/who-works`),
  workerDay: (employeeId: string) => api<WorkerDay>(`${B}/worker-day/${encodeURIComponent(employeeId)}`),
  missingHours: () => api<MissingHoursResponse>(`${B}/missing-hours`),
  fillMissingHours: (rows: MissingHoursFill[]) =>
    api<{ filled: number }>(`${B}/missing-hours/fill`, { method: 'POST', body: { rows } }),
};

export const PC_KEYS = {
  whoWorks: ['production-center', 'who-works'] as const,
  missingHours: ['production-center', 'missing-hours'] as const,
};

/** נוכחים / על שעון / ללא שעון — אותו חישוב כמו כותרת הטלוויזיה. */
export function floorCounts(departments: TvDepartment[]): { present: number; onClock: number; idle: number } {
  const onClock = departments.reduce((a, d) => a + d.clocks.reduce((b, c) => b + c.workers.length, 0), 0);
  const idle = departments.reduce((a, d) => a + d.idle.length, 0);
  return { present: onClock + idle, onClock, idle };
}
